import { Component, Inject, OnInit } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import {
  EstadoDocumentoItem,
  EstadoSolicitudItem,
  EstadoSolicitudPersonaItem,
  SolicitudSeccion,
} from 'src/app/models/common/enumModel';
import { ISolicitudPersonaModel } from 'src/app/models/interfaces/solicitud/ISolicitudPersonaModel';
import { ISolicitudPersonaValidarModel } from 'src/app/models/interfaces/solicitud/personal/ISolicitudPersonaValidarModel';
import { DocumentacionRequeridaModel } from 'src/app/models/solicitud/DocumentacionRequeridaModel';
import { SolicitudDocumentoModel } from 'src/app/models/solicitud/documento/SolicitudDocumentoModel';
import { SolicitudPersonaValidarModel } from 'src/app/models/solicitud/personal/SolicitudPersonaValidarModel';
import { PersonalModel } from 'src/app/models/solicitud/PersonalModel';
import { SolicitudPersonaDocumentosService } from 'src/app/services/solicitud-persona-documentos/solicitud-persona-documentos.service';
import { SolicitudPersonaService } from 'src/app/services/solicitud-persona/solicitud-persona.service';
import * as fileSaver from 'file-saver';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { VisorPdfDialogComponent } from 'src/app/components/shared/visor-pdf-dialog/visor-pdf-dialog.component';
import { VisorPdfDocumentoModel } from 'src/app/models/common/VisorPdfDocumentoModel';

@Component({
  selector: 'app-validar-personal-dialog',
  templateUrl: './validar-personal-dialog.component.html',
  styleUrls: ['./validar-personal-dialog.component.css'],
})
export class ValidarPersonalDialogComponent implements OnInit {
  model!: ISolicitudPersonaModel;
  modelPersona: ISolicitudPersonaValidarModel;
  displayedColumns: string[] = [
    'nombre',
    'idRequisito',
    'fechaVencimiento',
    'idDocumento',
    'aprobado',
    'observado',
  ];

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ValidarPersonalDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PersonalModel,
    private solicitudPersonaService: SolicitudPersonaService,
    private solicitudPersonaDocumentoService: SolicitudPersonaDocumentosService,
    private alertDialogService: AlertDialogService
  ) {
    this.model = new PersonalModel();
    this.modelPersona = new SolicitudPersonaValidarModel();
  }

  ngOnInit(): void {
    this.solicitudPersonaService
      .getById(this.data.idSolicitud, this.data.idSolicitudPersona)
      .subscribe((p) => {
        // console.log(p);
        this.model = p;
        this.model.idSolicitud = this.data.idSolicitud;
        this.model.codigoSolicitud = this.data.codigoSolicitud;
        this.model.logs =  this.model.logs.filter(p => p.comentarios != "" && p.comentarios != null);
        // EstadoDocumentoItem.APROBADO
        this.model.documentos.forEach((p) => {
          p.aprobado = p.idEstado === EstadoDocumentoItem.APROBADO;
          p.observado = p.idEstado === EstadoDocumentoItem.OBSERVADO;
        });
        this.modelPersona.idSolicitudPersona = this.data.idSolicitudPersona;
        //this.modelPersona.comentarios = this.data.comentarios;
        this.modelPersona.idEstado = this.data.idEstado;
      });
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  enviar() {
    let pendientes = this.model.documentos.filter(
      (p) => !p.aprobado && !p.observado
    ).length;

    let pendientesObservados = this.model.documentos.filter(
      (p) => p.observado
    ).length;

    // console.log(this.modelPersona);

    if (
      pendientes == 0 &&
      pendientesObservados >= 1 &&
      (this.modelPersona.comentarios == '' || !this.modelPersona.comentarios)
    ) {
      this.alertDialogService.open('Debe ingresar un comentario');
    } else {
      this.model.documentos.forEach((p) => {
        //.filter((p) => p.nombreArchivo !=  '')
        let documento = new SolicitudDocumentoModel();
        documento.idEstado = p.idEstado;
        documento.idDocumento = p.idSolicitudPersonaDocumento;
        if (p.aprobado) {
          documento.idEstado = EstadoDocumentoItem.APROBADO;
        } else if (p.observado) {
          documento.idEstado = EstadoDocumentoItem.OBSERVADO;
        }
        else{
          documento.idEstado = EstadoDocumentoItem.PENDIENTE;
        }

        this.modelPersona.documentos.push(documento);
      });

      //console.log(this.modelPersona);
      this.solicitudPersonaService.validar(this.modelPersona).subscribe((p) => {
        
        if(pendientes == 0){
          if(pendientesObservados > 0)
          this.alertDialogService.open('Se registró su observación y se notificó al contratista');
          else
          this.alertDialogService.open('Se registró su aprobación');
          this.alertDialogService.closed().subscribe((confirmed) => {
            this.dialogRef.close(true);
          });
        }
        else
          this.dialogRef.close(true);
        
      });
    }
  }

  changeAprobado(element: DocumentacionRequeridaModel) {
    if (element.aprobado) element.observado = false;
  }

  changeObservado(element: DocumentacionRequeridaModel) {
    // element.aprobado = !element.observado;
    if (element.observado) element.aprobado = false;
  }

  downloadDocumentFromService(element: DocumentacionRequeridaModel) {
    if (element.permiteVisor) {
      let modelVisor: VisorPdfDocumentoModel = new VisorPdfDocumentoModel();
      modelVisor.seccion = SolicitudSeccion.Personal;
      modelVisor.idRegistro = this.modelPersona.idSolicitudPersona;
      modelVisor.idSolicitudDocumento = element.idSolicitudPersonaDocumento;
      modelVisor.codigoSolicitud = this.model.codigoSolicitud;
      modelVisor.nombreArchivo = element.nombreArchivo;
      const dialogVisroRef = this.dialog.open(VisorPdfDialogComponent, {
        width: '1300px',
        data: modelVisor,
        autoFocus: false,
      });
    }
    else {
      this.solicitudPersonaDocumentoService.downloadDocumento(
        this.model.codigoSolicitud,
        this.modelPersona.idSolicitudPersona,
        element.idSolicitudPersonaDocumento
      ).subscribe(data => {
        let blob: any = new Blob([data], { type: 'text/json; charset=utf-8' });
        fileSaver.saveAs(blob, element.nombreArchivo);
      });
    }
  }
}
